import { Stack, TextField } from "@mui/material";
import { MprcContainer, MprcRequestIndicator, MprcTypography } from "components";
import { ButtonCancel, ButtonSave } from "components/buttons";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { MprcSimpleDialog } from "components/MprcSimpleDialog";
import { enqueueSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    channelId: string;
    onClose: (success?: boolean) => void;
}

export const ChannelRequestAccess: React.FC<IProps> = ({ channelId, onClose }) => {
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    var [loading, setLoading] = useState<boolean>(false);
    var [reason, setReason] = useState<string>();
    const handleSave = () => {
        if (reason?.length == 0) return;

        setLoading(true);
        api.v1.channelManagement.requestAccess({
            channelId,
            reason: reason!
        }).then(({ data: success }) => {
            if (!success) enqueueSnackbar("Não foi possível solicitar acesso.");
            else {
                onClose(success);
            }
        }).catch(e => MprcRequestSnackbarErrorReport(e))
            .finally(() => {
                setLoading(false);
            });

    };

    return <MprcSimpleDialog
        title={t("Channel.ChannelRequestAccessDialog.Title")}
        width="xs"
        message={
            <>
                <MprcRequestIndicator visible={loading} />
                <MprcContainer margin="large">
                    <TextField
                        autoFocus
                        required
                        fullWidth
                        minRows={3}
                        value={reason ?? ""}
                        onChange={e => setReason(e.target.value)}
                        label={t("Channel.ChannelRequestAccessDialog.ReasonLabel")}
                        placeholder={t("Channel.ChannelRequestAccessDialog.ReasonPlaceholder")}
                        helperText={
                            <MprcTypography variant="caption" color="warning">
                                {t("Channel.ChannelRequestAccessDialog.ReasonHint")}
                            </MprcTypography>
                        }
                        error={reason != undefined && reason.length == 0}
                        multiline={true}
                    />
                </MprcContainer>
                <Stack direction="row" width="100%" justifyContent={"end"} alignItems="center" gap={1}>
                    <ButtonCancel onClick={() => onClose()}></ButtonCancel>
                    <ButtonSave disabled={reason?.length == 0} text={t("Channel.ChannelRequestAccessDialog.SaveButtonText")} onClick={handleSave} />
                </Stack>
            </>
        }
        onClose={onClose}
    />;
};